import React from 'react'

export interface AuthUser {
  id: number
  email: string
  name: string
  role: string
}

export interface AuthContextValue {
  user: AuthUser | null
  loading: boolean
  login: (
    email: string,
    password: string
  ) => Promise<{ ok: boolean; error?: string }>
  logout: () => void
  refreshUser: () => Promise<void>
}

export const AuthContext = React.createContext<AuthContextValue | null>(null)
